import { render, staticRenderFns } from "./ColorPanel.vue?vue&type=template&id=d16bcbba&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d16bcbba')) {
      api.createRecord('d16bcbba', component.options)
    } else {
      api.reload('d16bcbba', component.options)
    }
    module.hot.accept("./ColorPanel.vue?vue&type=template&id=d16bcbba&", function () {
      api.rerender('d16bcbba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/partials/ColorPanel.vue"
export default component.exports